/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameTextIcon32Regular = forwardRef('ScanFrameTextIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M24 3a5 5 0 0 1 5 5v3a1 1 0 1 1-2 0V8a3 3 0 0 0-3-3h-3a1 1 0 1 1 0-2h3Z" }),
        React.createElement("path", { d: "M3 24a5 5 0 0 0 5 5h3a1 1 0 1 0 0-2H8a3 3 0 0 1-3-3v-3a1 1 0 1 0-2 0v3Z" }),
        React.createElement("path", { d: "M29 24a5 5 0 0 1-5 5h-3a1 1 0 1 1 0-2h3a3 3 0 0 0 3-3v-3a1 1 0 1 1 2 0v3Z" }),
        React.createElement("path", { d: "M3 8a5 5 0 0 1 5-5h3a1 1 0 1 1 0 2H8a3 3 0 0 0-3 3v3a1 1 0 1 1-2 0V8Z" }),
        React.createElement("path", { d: "M10 20a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" }),
        React.createElement("path", { d: "M9 16a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M10 10a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H10Z" })));
});
